import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';

export const SimpleMfeRetracement = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const defaultFn = () => {};
  const isEnabled = tradePlanForm.exitTactics.MFE_RETRACEMENT ?? false;

  const retracePct =
    tradePlanForm.exitTactics.MFE_RETRACEMENT?.retracePct ?? 50;
  const setRetracePct =
    tradePlanForm.exitTactics.MFE_RETRACEMENT?.setRetracePct ?? defaultFn;

  const activationValue =
    tradePlanForm.exitTactics.MFE_RETRACEMENT?.activationValue ?? 0;
  const setActivationValue =
    tradePlanForm.exitTactics.MFE_RETRACEMENT?.setActivationValue ?? defaultFn;

  return (
    <div className={style.container}>
      <div className={style.labelAndCheckbox}>
        <input
          style={{ margin: '0 5px 0 0' }}
          type="checkbox"
          checked={isEnabled}
          onChange={() => {
            if (isEnabled) {
              tradePlanForm.removeExitTactic('MFE_RETRACEMENT');
            } else {
              tradePlanForm.addExitTactic('MFE_RETRACEMENT');
            }
          }}
        />
        <Body3 fontWeight={700} color={colors.lightGrey}>
          MFE Retracement
        </Body3>
      </div>
      <div className={style.controls}>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Retrace %</Body4>
          <NumericalInput
            disabled={!isEnabled}
            width="50px"
            maxHeight="23px"
            icon="%"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={retracePct}
            onChange={setRetracePct}
          />
        </div>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Activation Amount</Body4>
          <NumericalInput
            disabled={!isEnabled}
            width="50px"
            maxHeight="23px"
            icon="%"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={activationValue}
            onChange={setActivationValue}
          />
        </div>
      </div>
    </div>
  );
});
